import { normalizeMenuPath } from '@/components/portal/common/utils/menuPath'
import { localizeRouteLocation } from '@/components/portal/common/utils/localePath'
import store from '@/store'

/** 标准化路由 path 便于比较 */
export function normalizeRoutePath(path) {
  return normalizeMenuPath(path)
}

function currentLocale() {
  return store.state.locale?.current || ''
}

function localizeTo(to) {
  return localizeRouteLocation(to, currentLocale())
}

/** 判断目标路由是否与当前路由相同 */
export function isSameRouteLocation(router, to) {
  if (!router || to == null || to === '') return true

  const current = router.currentRoute.value
  const resolved = router.resolve(to)
  return resolved.fullPath === current.fullPath
}

/** 仅在目标与当前不同时 replace，避免导航死循环 */
export function safeRouterReplace(router, to) {
  if (!router || to == null || to === '') {
    return Promise.resolve(router?.currentRoute.value)
  }
  if (isSameRouteLocation(router, to)) {
    return Promise.resolve(router.currentRoute.value)
  }
  return router.replace(to)
}

/** 仅在目标与当前不同时 push，避免重复导航 */
export function safeRouterPush(router, to) {
  if (!router || to == null || to === '') {
    return Promise.resolve(router?.currentRoute.value)
  }
  if (isSameRouteLocation(router, to)) {
    return Promise.resolve(router.currentRoute.value)
  }
  return router.push(to)
}

/** 全局拦截 push/replace/resolve，补上语言前缀并防止跳转到当前相同路由 */
export function patchRouterNavigation(router) {
  if (!router || router.__safeNavigationPatched) return router

  const originalResolve = router.resolve.bind(router)
  router.resolve = function patchedResolve(to, current) {
    return originalResolve(localizeTo(to), current)
  }

  ;['push', 'replace'].forEach((method) => {
    const original = router[method].bind(router)
    router[method] = function patchedNavigation(to) {
      const localized = localizeTo(to)
      if (isSameRouteLocation(router, localized)) {
        return Promise.resolve(router.currentRoute.value)
      }
      return original(localized)
    }
  })

  Object.defineProperty(router, '__safeNavigationPatched', {
    value: true,
    enumerable: false,
    configurable: false
  })

  return router
}
